export var PdsClientEventName = {
  CLIENT_INIT: 'CLIENT_INIT',
  CLIENT_AUTHENTICATION_SUCCESS: 'CLIENT_AUTHENTICATION_SUCCESS',
  CLIENT_AUTHENTICATION_FAILED: 'CLIENT_AUTHENTICATION_FAILED',
  CLIENT_CONFIGURATION_FINISHED: 'CLIENT_CONFIGURATION_FINISHED',
  CLIENT_INTERACTIVE_DOCUMENT_TRANSACTION_COMPLETE: 'CLIENT_INTERACTIVE_DOCUMENT_TRANSACTION_COMPLETE_SUCCESS',
  CLIENT_SSO_AUTHENTICATION_SUCCESS: 'CLIENT_SSO_AUTHENTICATION_SUCCESS',
  CLIENT_SSO_AUTHENTICATION_FAILED: 'CLIENT_SSO_AUTHENTICATION_FAILED'
};
export var PdsVendorEventName = {
  VENDOR_INIT: 'VENDOR_INIT'
};